import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { familiarItems } from "../../data/content";
export function SoundFamiliar() {
  return <section className="bg-paper px-4 py-16 sm:px-6 sm:py-24" data-id="element-270" data-mp="mqmhlxls7lx1">
      <div className="mx-auto max-w-5xl" data-id="element-271" data-mp="msfo9cwea651">
        <SectionHeading eyebrow="Does any of this sound familiar?" title="If You Recognize Yourself Here, I Created This for You." data-id="element-272" data-mp="qqwvdwftfgmg" />

        <ol className="mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-273" data-mp="cygo2jfvswfq">
          {familiarItems.map((item, i) => <li key={item.title} className="flex gap-4 rounded-3xl bg-white p-5 sm:p-7" data-id="element-274" data-mp="32do9k8i59vy" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cta font-display text-xl font-black text-white" data-id="element-275" data-mp="816s0kxzlmix">
                {i + 1}
              </span>
              <div data-id="element-276" data-mp="3q960wamhfhfp">
                <h3 className="font-display text-lg font-extrabold leading-snug text-ink sm:text-xl" data-id="element-277" data-mp="3v5mv9mk9ys18">{item.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-278" data-mp="slar43521p6p">{item.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-14 rounded-3xl bg-navy px-6 py-10 text-center sm:px-12 sm:py-14" data-id="element-279" data-mp="omjqhm1drpeu">
          <h3 className="font-display text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-280" data-mp="12i5ogipldjje">
            You Don’t Have to Keep Everything in Your Head.
          </h3>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-281" data-mp="9wcjq3kqjutz">
            I created the Musculoskeletal Clinical Pathway™ to help you organize your assessment process, review important
            warning signs, and approach clinical reasoning with a clearer structure.
          </p>
          <SectionCta dark label="Get the Complete System for $27" data-id="element-282" data-mp="et306s0gcsfx" />
        </div>
      </div>
    </section>;
}